import React from 'react'
import PauseIcon from '@mui/icons-material/Pause'
import MusicNoteIcon from '@mui/icons-material/MusicNote'
import './music.css'
const MusicButton = ({
  enabled,
  isMusicPlaying,
  toggleMusic,
  theme
}) => {

  if (!enabled) {
    return null;
  }

  return (
    <div
    //   className='music-handler'
       className={`music-handler ${theme || ''}`}
      onClick={toggleMusic}
      role="button"
      aria-label="Toggle music"
    >
      {isMusicPlaying ? (
        <PauseIcon className='music-icon' />
      ) : (
        <MusicNoteIcon className='music-icon' />
      )}
    </div>
  );
};

export default MusicButton;